import React, { Component } from 'react';
import { Container, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { Doughnut } from 'react-chartjs-2';
import Skeleton from 'react-loading-skeleton';
import NavBar from './Layout/NavBar';
import SideBar from './Layout/SideBar';
import Content from './Layout/Content';
import Tile from './Layout/Tile';
import Search from './Jobs/Search';
import JobList from './Jobs/JobList';
import Panel from './Layout/Panel';
import Actions from '../../Actions';
import Api from '../../Configs';

class Dashboard extends Component {

    transformData = () => {
        const { stats = {} } = this.props.dashboard;
        const labels = [];
        const totals = [];
        const backgroundColors = [];
        const icons = [];
        const ids = [];
        Object.keys(Api.STATUSES).map((index) => {
            stats.hasOwnProperty(index) ? totals.push(stats[index].total) : totals.push(0);
            labels.push(Api.STATUSES[index].name);
            backgroundColors.push(Api.STATUSES[index].color);
            icons.push(Api.STATUSES[index].icon);
            ids.push(Api.STATUSES[index].id);
        });

        return { labels, totals, backgroundColors, icons, ids };
    }

    dashboard = () => {
        const { url, dashboard } = this.props;
        const data = this.transformData();
        const { totals = [] , backgroundColors = [], labels = [], ids=[] } = data;
        const chartConfig = {
            datasets: [{
                data: totals,
                backgroundColor: backgroundColors,
            }],
            labels: labels,
        };

        return (
            <div>
                <Tile xs="12">
                    <Container>
                        { dashboard.statsLoading ? <Skeleton count={4} /> : 
                            <Row>
                                {
                                    data.labels.map((label, index) => (
                                        <Panel key={index} title={label} link={`/jobs#status=${ids[index]}`} color={data.backgroundColors[index]} total={data.totals[index]} icon={data.icons[index]} />
                                    ))
                                }
                            </Row>
                        }
                    </Container>
                </Tile>

                <Tile xs="12" style={{marginTop:"20px"}}>
                    <Search /><br/>
                    <JobList url={url} />
                </Tile>

                <Tile xs="12" style={{marginTop:"20px"}}>
                    { dashboard.statsLoading ? <Skeleton count={15} /> : 
                        <Doughnut height={85} data={chartConfig} legend={{display: true, position: 'right'}}/>
                    }
                </Tile>
            </div>
        );
    }

    render(){
        const dashboard = this.dashboard();
        return (
            <div>
                <NavBar />
                <Container className="px-0" fluid>
                    <Row className="m-0">
                        <SideBar />
                        <Content>
                            {dashboard}
                        </Content>
                    </Row>

                </Container>
            </div>            
        );
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
    query: state.jobStore.query,
    dashboard: state.dashboard,
});
export default connect(mapStateToProps,Actions.dashboard)(Dashboard);


// WEBPACK FOOTER //
// ./src/Components/App/Dashboard.js